const styles = {
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
  tabProps: { sx: { display: 'none' } },
  tab: { '& .MuiTabs-flexContainer': { flexWrap: 'wrap' } },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  icon: {
    color: 'primary.white',
  },
  checkbox: { color: 'white', '&.Mui-checked': { color: 'white' } },
};

export default styles;
